import '@updater-components/loading-spinner';
import { ITEM_STATUSES } from '../../../constants/items';
import { actions, selectors } from '../../../state';
import template from './phases-timeline.html';
import './phases-timeline.global.css';

class PhasesTimelineController {
  loading = true;
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onChanges() {
    this.accountOpenedStep = {
      completedDescription: 'Account Opened',
      status: ITEM_STATUSES.COMPLETED,
      statusUpdatedAt: this.signedUpAt,
      timelineEnd: true,
    };

    this.moveDateStep = {
      shortDescription: 'Move Date',
      statusUpdatedAt: this.moveDate,
      timelineEnd: true,
    };
  }

  handlePhaseAccordionClick({ analytics }) {
    if (analytics) {
      this.updStore.dispatch(
        actions.analytics.track(analytics.event, analytics.properties)
      );
    }
  }
}

export const PhasesTimelineComponent = {
  bindings: {
    phases: '<',
    moveDate: '@',
    signedUpAt: '@',
    expandedChange: '&',
    statusChange: '&',
  },
  controller: PhasesTimelineController,
  template,
};
